import React, { useEffect, useState } from "react";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { db } from "../../firebase";

// Compact dashboard panel summarizing owner report-email delivery. Reads the
// `mail` collection (where the emailOwnerOnInspectionComplete function queues
// reports and the Trigger Email extension stamps delivery.state). Self-contained
// so it can drop into the dashboard rail without touching the dashboard's data
// hook. Links to the full /email-reports page.
const EmailReportsSummary = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ sent: 0, failed: 0, queued: 0 });
  // Owner reports held by review-before-send mode, waiting on an admin.
  const [toReview, setToReview] = useState(0);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        // Bound the read: mail is append-only and grows forever, so tally only
        // the most recent N — recent delivery health is what this panel shows.
        // Fall back to an unordered read if the ordered one can't run.
        const snap = await getDocs(
          query(
            collection(db, "mail"),
            orderBy("_meta.createdAt", "desc"),
            limit(200),
          ),
        ).catch(() => getDocs(collection(db, "mail")));
        const c = { sent: 0, failed: 0, queued: 0 };
        snap.docs.forEach((d) => {
          const state = d.data()?.delivery?.state;
          if (state === "SUCCESS") c.sent += 1;
          else if (state === "ERROR") c.failed += 1;
          else c.queued += 1; // no delivery yet (or in-flight) => waiting
        });
        if (active) setCounts(c);
      } catch (error) {
        // Non-critical dashboard widget; the page itself surfaces errors.
        console.error("EmailReportsSummary load failed:", error);
      }
      try {
        const held = await getDocs(
          query(
            collection(db, "inspections"),
            where("ownerReportStatus", "==", "pending_review"),
          ),
        );
        if (active) setToReview(held.size);
      } catch (error) {
        console.error("EmailReportsSummary review count failed:", error);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="sh-panel sh-rise" style={{ animationDelay: "300ms" }}>
      <div className="sh-panel-head">
        <h2 className="sh-panel-title">Report emails</h2>
        <button className="sh-link" onClick={() => navigate("/email-reports")}>
          View all
        </button>
      </div>
      <div
        style={{ display: "flex", gap: 8, flexWrap: "wrap", padding: "4px 2px" }}
      >
        {toReview > 0 && (
          <Tag
            color="gold"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/email-reports")}
          >
            To review {toReview}
          </Tag>
        )}
        <Tag color="green">Sent {counts.sent}</Tag>
        <Tag color="red">Failed {counts.failed}</Tag>
        <Tag color="default">Queued {counts.queued}</Tag>
      </div>
    </div>
  );
};

export default EmailReportsSummary;
